const snackResponse = {
  mostrar: false,
  texto: '',
  color: '',
};

export default {
  cerrarSnack({ commit }) {
    commit('MOSTRAR_SNACKBAR', { snackResponse });
  },
};
